module.exports = __webpack_public_path__ + "assets/img/TTC108.17ad4204.png";